import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=24a366c0&scoped=true"
import script from "./IconBox.vue?vue&type=script&lang=js"
export * from "./IconBox.vue?vue&type=script&lang=js"
import style0 from "./IconBox.vue?vue&type=style&index=0&id=24a366c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a366c0",
  null
  
)

export default component.exports